import { useEffect, type ReactNode } from "react";

// Every page starts with one of these: the title in the audit register with
// the glow underline, a one-line caption, and an optional right-hand slot.

type Props = { title: string; caption?: ReactNode; right?: ReactNode };

export function PageHead({ title, caption, right }: Props) {
  useEffect(() => {
    document.title = `${title} | Dime Motion`;
  }, [title]);

  return (
    <section className="section compact phead">
      <div className="shead">
        <h1 className="stitle">{title}</h1>
        {right ? <div className="sright">{right}</div> : null}
      </div>
      {caption ? <p className="sdesc">{caption}</p> : null}
    </section>
  );
}

/** A section head inside a page: h2 in the same register, with an optional right slot. */
export function SectionHead({ title, right, caption }: Props) {
  return (
    <>
      <div className="shead">
        <h2 className="stitle">{title}</h2>
        {right ? <div className="sright">{right}</div> : null}
      </div>
      {caption ? <p className="sdesc">{caption}</p> : null}
    </>
  );
}
